import React, { useState, useEffect } from 'react';
import { checkMenu } from '../Utils/Common';
import DefaultLayout from '../component/DefaultLayout';
import Footer from '../component/Footer';
import Api from '../config/Api';

import { AiOutlinePlus, AiFillEdit, AiFillDelete } from 'react-icons/ai'
import { BsCardChecklist } from 'react-icons/bs'
import { GoVerified ,GoUnverified } from "react-icons/go";
import { CgBlock, CgUnblock } from "react-icons/cg";
import { SiMinutemailer } from "react-icons/si";

import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Card from 'react-bootstrap/Card';
import Navbar from 'react-bootstrap/Navbar';
import Form from 'react-bootstrap/Form';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link, useHistory } from 'react-router-dom';
import ReactPaginate from "react-paginate";
import { FiSearch } from "react-icons/fi";
import moment from 'moment'
import Badge from 'react-bootstrap/Badge';
import Accordion from 'react-bootstrap/Accordion';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import { confirm } from "react-confirm-box";
import 'bootstrap/dist/css/bootstrap.min.css';

function CustomToggle({ children, eventKey }) {
  const decoratedOnClick = useAccordionButton(eventKey, () => console.log());

  return (
    <Card.Header
      onClick={decoratedOnClick}
    >
      {children}
    </Card.Header>
  );
}

function Services() {
  const history = useHistory()
  const [dataList, setDataList] = useState([])

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [keyword, setKeyword] = useState("");
  const [query, setQuery] = useState("");
  const newDate = new Date(Date.now() + (1*24*60*60*1000));
  
  useEffect(() => {
    getDataList()        
  }, [page, keyword]);

  const getDataList = async () => {
    await Api().get(`services?filter=${keyword}&fields=name,descriptions&page=${page}&limit=${limit}&sort=_id&order=1`)
    .then((response) => response)
    .then( async (data) => {
      const listData = data.data;

      const dataParent = listData.docs;
      for( var i=0; i<dataParent.length; i++)
      {
        if( dataParent[i]._id !== dataParent[i].parent_id._id )
        {
          await Api().get(`services/${dataParent[i].parent_id._id}`)
          .then((response) => response)
          .then((data) => {
            if(data.status === 200 || data.status === 201 )
            {
              if( data.data.parent_id.name !== dataParent[i].parent_id.name )
              {
                dataParent[i].parent_id.parent = data.data.parent_id.name
              }
            }
          })
          .catch((err) => {
          });
        }
      }

      setDataList(dataParent);
      setPage(listData.page);
      setPages(listData.totalPages);
      setRows(listData.totalDocs);
    })
    .catch((err) => {
    })
  }

  const changePage = ({ selected }) => {
    setDataList([])
    setPage(selected+1);
  }

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setKeyword(query);
  }

  const handleDelete = async (e) => {
    const id = e.target.attributes.getNamedItem("data-id").value

    const confirm_action = await confirm("Anda yakin ingin menghapus data ini?");
    if (confirm_action) {
      await Api().delete(`hospitals/${id}`)
      .then((response) => response)
      .then((res) => {
        if( res.status === 200 ){
          for (let i = dataList.length - 1; i >= 0; --i) {
            if (dataList[i]._id === id) dataList.splice(i, 1);
          }
          setDataList(dataList);
          history.push('/hospitals')
        }
      })
      .catch((err) => {
          
      });
    }
  }


  return (
    <>
      <div style={{ display: 'flex', height: '100%', direction: 'ltr' }}>
                <DefaultLayout />
                {/* <div className={ getStyles().collapsed === true ? 'content-wrapper collapsed' : 'content-wrapper' }> */}
                <main>
                    <div className="content-header">
                        <Container fluid>
                            <Row className="">
                                <Col sm={4}>
                                <h1 className="m-0">Services</h1>
                                </Col>
                                <Col sm={2}>
                                    { checkMenu('addservice') &&
                                        <Link to="addservice"><Button variant="outline-primary" className="btn-upload"><AiOutlinePlus /> Add Service</Button></Link>
                                    }
                                </Col>
                                <Col sm={3}>
                                <Form className="d-flex" onSubmit={searchData}>
                                    <Form.Control
                                    type="search"
                                    placeholder="Search"
                                    className="me-2 input-search"
                                    aria-label="Search"
                                    value={query}
                                    onChange={(e) => setQuery(e.target.value)}
                                    />
                                    <Button type="submit" className="btn-search"><FiSearch /></Button>
                                </Form>
                                </Col>
                                <Col sm={3}>
                                <div className="date-time float-sm-right">
                                    { moment().format('dddd, DD MMMM YYYY') }
                                </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                        
                    <div className="content">
                        <Container fluid>
                            <Row>
                                <Col lg={12} style={{padding: '0'}}>
                                <Table striped hover size="sm">
                    {/* <Table striped hover responsive> */}
                      <thead className='thead'>
                        <tr>
                          <th style={{ width: '5%'}} className="text-center">No</th>
                          <th style={{ width: '30%'}} className="text-left">Parent Service</th>
                          <th style={{ width: '30%'}} className="text-left">Service</th>
                          <th style={{ width: '30%'}} className="text-left">Descriptions</th>
                          <th style={{ width: '5%'}} className="text-left"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          dataList.map((item, i) => (
                            <tr key={i}>
                              <td className="text-center">
                                  {page === 1 ?
                                      i+1 : ( limit * (page-1) ) + (i+1)
                                  }
                              </td>
                              <td className="text-left">{item._id === item.parent_id._id ? item.name : typeof(item.parent_id.parent) !== 'undefined' ? item.parent_id.parent + ' - ' + item.parent_id.name : item.parent_id.name }</td>
                              <td className="text-left">{item._id === item.parent_id._id ? '' : item.name}</td>
                              <td className="text-left">{item.descriptions}</td>
                              <td className="text-left">
                                <NavDropdown title="Action" className='' id="basic-nav-dropdown">
                                    { checkMenu('editservice') && 
                                        <NavDropdown.Item href={ "editservice/" + item._id }><AiFillEdit /> Change</NavDropdown.Item>
                                    }
                                    { checkMenu('deleteservice') && 
                                        <NavDropdown.Item href="#" onClick={handleDelete} data-id={item._id}><AiFillDelete /> Delete</NavDropdown.Item>
                                    }
                                </NavDropdown>
                                </td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </Table>
                <Card className="content-list">
                  <Card.Footer>
                    <Row>
                      <Col lg={3}>
                        <p>Total Data: {rows} Page: {rows ? page : 0} of {pages}</p>
                      </Col>
                      <Col lg={9}>
                        <nav
                          className="pagination float-sm-right"
                          key={rows}
                          role="navigation"
                          aria-label="pagination"
                        >
                          <ReactPaginate
                            previousLabel={"< Prev"}
                            nextLabel={"Next >"}
                            pageCount={pages}
                            onPageChange={changePage}
                            containerClassName={"pagination-list pagination"}
                            pageLinkClassName={"pagination-link page-link"}
                            previousLinkClassName={"pagination-previous page-link"}
                            nextLinkClassName={"pagination-next page-link"}
                            activeLinkClassName={"pagination-link is-current"}
                            disabledLinkClassName={"pagination-link is-disabled"}
                            activeClassName={"active"}
                            pageClassName={"page-item"}
                          />
                        </nav>
                      </Col>
                    </Row>
                  </Card.Footer>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
        </main>
      </div>
      <Footer />
    </>
  )
}
export default Services
